var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v("Rol de Pago de Recaudador " + _vm._s(_vm.numero_documento))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.consultaRealizada,
                    expression: "!consultaRealizada"
                  }
                ],
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.consultaRealizada &&
                      _vm.imprimir_rol_recaudacion_pdf &&
                      _vm.id !== "",
                    expression:
                      "consultaRealizada && imprimir_rol_recaudacion_pdf && id !== ''"
                  }
                ],
                staticClass: "btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.imprimirPdf }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("Imprimir en PDF")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.consultaRealizada &&
                      _vm.imprimir_rol_recaudacion_excel &&
                      _vm.id !== "",
                    expression:
                      "consultaRealizada && imprimir_rol_recaudacion_excel && id !== ''"
                  }
                ],
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.imprimirExcel }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Imprimir en Excel")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.consultaRealizada && _vm.puedeGuardar,
                    expression: "consultaRealizada && puedeGuardar"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.cerrar }
              },
              [
                _c("i", { staticClass: "fa fa-check" }),
                _c("span", [_vm._v("Guardar Rol")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.consultaRealizada,
                    expression: "consultaRealizada"
                  }
                ],
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.cancelar }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _c("span", [_vm._v("Cancelar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.bodegas.length == 1
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.bodegas,
                          label: "descripcion",
                          placeholder: "Seleccione..."
                        },
                        on: { input: _vm.inputSucursal },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodega" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.consultaRealizada
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "supervisor_id",
                          options: _vm.recaudadores,
                          label: "nombre"
                        },
                        on: {
                          input: _vm.inputRecaudador,
                          search: _vm.searchRecaudadores
                        },
                        model: {
                          value: _vm.selectedRecaudador,
                          callback: function($$v) {
                            _vm.selectedRecaudador = $$v
                          },
                          expression: "selectedRecaudador"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "supervisor_id" } }, [
                        _vm._v("Recaudador")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        disabled: _vm.consultaRealizada,
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        disabled: _vm.consultaRealizada,
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.consultaRealizada,
              expression: "consultaRealizada"
            }
          ],
          staticClass: "card"
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "custom-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [_vm._v("Inicial")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Nuevas (15 días)")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Activas")]),
                          _vm._v(" "),
                          _vm._l(_vm.porcentajesTarjeta, function(porc) {
                            return _c("th", { key: porc }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(porc) +
                                  " %\n                  "
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("th", [_vm._v("Zona")])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("tbody", [
                      _c(
                        "tr",
                        [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.form.inicial_tarjetas) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "form-field" },
                              [
                                _c("input-field", {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.int,
                                    readonly:
                                      !_vm.editar_15_dias_rol ||
                                      !_vm.puedeGuardar,
                                    placeholder: "# Tarjetas",
                                    id: "tarjetas_nuevas"
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.calcularTotales(true, true)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.tarjetas_nuevas,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "tarjetas_nuevas", $$v)
                                    },
                                    expression: "form.tarjetas_nuevas"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.form.tarjetas_activas) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.porcentajesTarjeta, function(porc) {
                            return _c("td", { key: porc }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-info btn--text",
                                  attrs: {
                                    disabled: !_vm.puedeGuardar,
                                    type: "button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.seleccionarPorcentaje(porc)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.calcularPorcRecaudacion(
                                          parseFloat(porc)
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [_vm._v(_vm._s(_vm.descripcion_ruta))])
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "custom-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", [_vm._v("Días")]),
                          _vm._v(" "),
                          _vm._l(_vm.registros, function(registro) {
                            return _c("th", { key: registro.fecha }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(registro.nombre_dia) +
                                  "\n                  "
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("th", [_vm._v("Total")])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("tbody", [
                      _c(
                        "tr",
                        [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Cobradas")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.registros, function(registro) {
                            return _c(
                              "td",
                              { key: registro.fecha + "cobradas" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(registro.cobradas) +
                                    "\n                  "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.form.tarjetas_cobradas) +
                                "\n                  "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Devoluciones")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.registros, function(registro) {
                            return _c(
                              "td",
                              { key: registro.fecha + "devoluciones" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(registro.devoluciones) +
                                    "\n                  "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.form.devoluciones_completas) +
                                "\n                  "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        [
                          _c("th", { attrs: { scope: "row" } }, [
                            _vm._v("Valor recaudado")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.registros, function(registro) {
                            return _c(
                              "td",
                              { key: registro.fecha + "valor_recaudado" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.moneyFormat(registro.valor_recaudado)
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.moneyFormat(_vm.form.valor_recaudado)
                                ) +
                                "\n                  "
                            )
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "custom-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Activas")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Tipo de supervisión")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Supervisadas")]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.tipo_supervision === "P",
                                expression: "form.tipo_supervision === 'P'"
                              }
                            ]
                          },
                          [_vm._v("Tarj. Supervisadas")]
                        ),
                        _vm._v(" "),
                        _c("th", [_vm._v("Dev. Completa")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Tot. Activas")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Cobradas")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("No Cobradas")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("%")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.form.tarjetas_activas) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "form-field select" }, [
                            _c("div", { staticClass: "select-field" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.tipo_supervision,
                                      expression: "form.tipo_supervision"
                                    }
                                  ],
                                  attrs: {
                                    disabled:
                                      !_vm.editar_supervision_rol ||
                                      !_vm.puedeGuardar,
                                    name: "tipo_supervision",
                                    id: "tipo_supervision"
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "tipo_supervision",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.inputTipoSupervision
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "P" } }, [
                                    _vm._v("Porcentaje")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "U" } }, [
                                    _vm._v("Unidades")
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c("input-field", {
                                attrs: {
                                  id: "tarjetas_supervisadas",
                                  vMoney: "",
                                  format:
                                    _vm.form.tipo_supervision === "P"
                                      ? _vm.porcentaje
                                      : _vm.int,
                                  readonly:
                                    !_vm.editar_supervision_rol ||
                                    !_vm.puedeGuardar,
                                  placeholder: "# Tarjetas"
                                },
                                on: { input: _vm.inputValorSupervision },
                                model: {
                                  value: _vm.form.valor_supervision,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "valor_supervision", $$v)
                                  },
                                  expression: "form.valor_supervision"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.tipo_supervision === "P",
                                expression: "form.tipo_supervision === 'P'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.form.tarjetas_supervisadas) +
                                "\n                  "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.form.devoluciones_completas) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.form.total_activas) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.form.tarjetas_cobradas) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.form.tarjetas_no_cobradas) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.form.porcentaje_cobro))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("p", [
                  _c("strong", [
                    _vm._v(
                      "Deuda total: " +
                        _vm._s(_vm.moneyFormat(_vm.deuda_recaudador))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card__content",
                    staticStyle: { "max-height": "300px" }
                  },
                  [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c("table", { staticClass: "custom-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Tipo de descuento")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Fecha")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Día")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Detalle")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Valor")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Saldo")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Valor seleccionado")]),
                            _vm._v(" "),
                            _c("th", [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.puedeGuardar,
                                      expression: "puedeGuardar"
                                    }
                                  ],
                                  staticClass: "btn-success",
                                  attrs: { tooltip: "Agregar venta" },
                                  on: { click: _vm.agregarMovimientos }
                                },
                                [_c("i", { staticClass: "fa fa-plus" })]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.form.movimientos, function(
                            movimiento,
                            index
                          ) {
                            return _c(
                              "tr",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.coincideMovimientos(movimiento),
                                    expression:
                                      "coincideMovimientos(movimiento)"
                                  }
                                ],
                                key: movimiento.id,
                                class: { "tr--canceled": movimiento.valor < 0 }
                              },
                              [
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        movimiento.descripcion_tipo_movimiento
                                      ) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(movimiento.fecha) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(movimiento.nombre_dia) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(movimiento.detalle) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.moneyFormat(movimiento.valor)
                                      ) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.moneyFormat(movimiento.saldo)
                                      ) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.moneyFormat(movimiento.valor_pago)
                                      ) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.puedeGuardar,
                                          expression: "puedeGuardar"
                                        }
                                      ],
                                      staticClass: "btn-danger btn--text",
                                      attrs: { tooltip: "Quitar" },
                                      on: {
                                        click: function($event) {
                                          return _vm.quitarMovimiento(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-times" })]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("tfoot", [
                          _c("tr", [
                            _c(
                              "th",
                              { attrs: { colspan: "6", scope: "row" } },
                              [_vm._v("Totales")]
                            ),
                            _vm._v(" "),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.moneyFormat(
                                      _vm.lodash.sumBy(
                                        _vm.form.movimientos,
                                        function(o) {
                                          return parseFloat(o.valor_pago)
                                        }
                                      )
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.consultaRealizada,
              expression: "consultaRealizada"
            }
          ],
          staticClass: "card mt-2"
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "custom-table" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("div", { staticClass: "form-field select" }, [
                            _c("div", { staticClass: "select-field" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.porcentaje_recaudador,
                                      expression: "form.porcentaje_recaudador"
                                    }
                                  ],
                                  attrs: {
                                    name: "porcentaje_recaudador",
                                    id: "porcentaje_recaudador",
                                    disabled: !_vm.puedeGuardar
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "porcentaje_recaudador",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.inputPorcRecaudador
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { disabled: "", value: "" } },
                                    [_vm._v("Seleccione...")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.porcentajesTarjeta, function(
                                    porcentaje
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: porcentaje,
                                        domProps: {
                                          value: parseFloat(porcentaje)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(porcentaje) +
                                            " %\n                          "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.moneyFormat(_vm.form.valor_pago)) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.moneyFormat(_vm.form.total_movimientos)
                              ) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(_vm.form.liquido_recibir))
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "tableSelectMov",
            height: "auto",
            width: "70%",
            scrollable: "",
            resizable: "",
            adaptive: "",
            reset: ""
          }
        },
        [
          _c("k-table-select", {
            ref: "kTableSelectMov",
            attrs: {
              columnas: [
                {
                  nombre: "tipo_movimiento.descripcion",
                  descripcion: "Tipo de movimiento"
                },
                {
                  nombre: "fecha",
                  descripcion: "Fecha",
                  sortable: true
                },
                {
                  nombre: "nombre_dia",
                  descripcion: "Día",
                  sortable: true
                },
                {
                  nombre: "detalle",
                  descripcion: "Detalle",
                  sortable: true
                },
                {
                  nombre: "valor",
                  descripcion: "Valor",
                  money: true,
                  sortable: true
                },
                {
                  nombre: "saldo",
                  descripcion: "Saldo",
                  money: true,
                  sortable: true
                },
                {
                  nombre: "valor_pago",
                  descripcion: "Valor seleccionado",
                  money: true,
                  sortable: true
                }
              ],
              saldoSeleccionable: "",
              params: {
                persona_id: _vm.form.recaudador_id,
                rol_recaudador_id: _vm.id
              },
              urlConsulta: _vm.url + "/movimientos-nomina-supervisor",
              title: "Seleccione uno o varios movimientos"
            },
            on: {
              cerrar: _vm.cerrarMovimientos,
              seleccionar: _vm.seleccionarMovimientos
            },
            model: {
              value: _vm.form.movimientos,
              callback: function($$v) {
                _vm.$set(_vm.form, "movimientos", $$v)
              },
              expression: "form.movimientos"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de Recaudador")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Rol")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("% Tarj.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descuentos +/-")]),
        _vm._v(" "),
        _c("th", [_vm._v("Líquido a recibir")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4540b86d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4540b86d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/RolRecaudador.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4540b86d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/RolRecaudador.vue
// module chunks = 0